export default __webpack_public_path__ + "static/media/reviews.26eefa3e.md";